import request from '@/utils/request'

const api = {
  Query(data) {
    return request({
      url: 'admin/user_money/list',
      method: 'post',
      data
    })
  },
  Delete(data) {
    return request({
      url: 'admin/user_money/destroy',
      method: 'post',
      data
    })
  },
  Update(data) {
    return request({
      url: 'admin/user_money/createOrUpdate',
      method: 'post',
      data
    })
  },
  Create(data) {
    return request({
      url: 'admin/user_money/createOrUpdate',
      method: 'post',
      data
    })
  }
}

export default api
